import { useMemo } from 'react';
import useConfiguration from '~/configuration/use-configuration';
import { getCasinoRoutes } from './casino-routes';

/**
 * Return casino routes based on license
 */
const useCasinoRoutes = () => {
	const { license } = useConfiguration();

	const casinoRoutes = useMemo(() => {
		return getCasinoRoutes(license);
	}, [license]);

	return casinoRoutes;
};

export default useCasinoRoutes;
